import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import UserManagerPresentational from '../presentational/UserManager';
import { ToastProvider } from '../../../context/ToastContext';

const UserManagerContainer = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const tagParam = queryParams.get('tags');
  const activeTag = tagParam || 'users';

  useEffect(() => {
    if (!tagParam) {
      navigate('?tags=users', { replace: true });
    }
  }, [tagParam, navigate]);

  return (
    <ToastProvider>
      <UserManagerPresentational {...props} activeTag={activeTag} />
    </ToastProvider>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserManagerContainer);
